import React, { useMemo } from 'react';

import { TempCard, TempCardHeader, TempCardHeaderText } from '../Card/index.style';
import Stack from '../Stack';
import { TableContainer } from './index.style';
import { TableHeader } from './types';

// Lendi TeamNavigation sticky height offset;
const TEAMNAV_TOP_PADDING = 56;

interface TableProps {
  children?: React.ReactNode;
  title?: string | React.ReactNode;
  headers: TableHeader[];
  after?: React.ReactNode;
  isSticky?: boolean;
}

function Table(props: TableProps) {
  const { tableSize, headerSizes } = useMemo(() => {
    const total = props.headers.reduce(
      (acc, curr) => {
        acc.min += curr.min;
        acc.max += curr.max;

        return acc;
      },
      { min: 0, max: 0 }
    );

    return {
      tableSize: { min: `${total.min}px`, max: `${total.max}px` },
      headerSizes: props.headers.map((header) => {
        const percentage = Math.floor((header.min / total.min) * 100);

        return { width: `${percentage}%`, min: `${header.min}px`, max: `${header.max}px` };
      }),
    };
  }, [props.headers]);

  return (
    <TempCard>
      {props.title && (
        <TempCardHeader>
          <Stack direction="row" halign="justify">
            <TempCardHeaderText>{props.title}</TempCardHeaderText>
            {props.after && <div>{props.after}</div>}
          </Stack>
        </TempCardHeader>
      )}
      <TableContainer
        top={`${TEAMNAV_TOP_PADDING}px`}
        tableSize={tableSize}
        headerSizes={headerSizes}
        isSticky={props.isSticky}
      >
        <table data-component="table">
          <thead>
            <tr>
              {props.headers.map((header, index) => (
                <th key={index} data-component="table-header">
                  {header.text}
                </th>
              ))}
            </tr>
          </thead>
          {props.children}
        </table>
      </TableContainer>
    </TempCard>
  );
}

export default Table;
